export default __webpack_public_path__ + "static/media/p_zajic_polni-min.2932028e.jpg";